import { useMemo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";

interface IProps {
  happycoWorkOrder?: HappycoWorkOrderFragment | null;
}

const useHappyco = ({ happycoWorkOrder }: IProps) => {
  const location = useMemo(() => {
    if (!happycoWorkOrder) {
      return null;
    }

    if (happycoWorkOrder.location && happycoWorkOrder.property) {
      return `${happycoWorkOrder.location} • ${happycoWorkOrder.property}`;
    }

    return happycoWorkOrder.location || happycoWorkOrder.property || null;
  }, [happycoWorkOrder]);

  return {
    happycoWorkOrder,
    location,
  };
};

export default useHappyco;
